export default "__VITE_ASSET__Hl9S3dUE__"